function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { withMedia } from 'react-media-query-hoc';
import { Checkbox } from '@domain-group/fe-co-form-elements';
import * as styles from './allhomes-checkbox-list.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ALL = '__ALL__';
export var AllModes = {
  ALL: 'all',
  TOGGLE: 'toggle',
  NONE_IS_ALL: 'none-is-all',
  ALL_IS_ALL: 'all-is-all',
  NONE: 'none'
};
var doCheckboxHandleAll = (allMode, selected, available, onChange) => {
  var allPossible = available.map(each => each.value).filter(each => each !== ALL);
  var newValues;
  switch (allMode) {
    case AllModes.ALL:
    case AllModes.ALL_IS_ALL:
      newValues = allPossible;
      break;
    case AllModes.TOGGLE:
      newValues = isEqual(selected, allPossible) ? [] : allPossible;
      break;
    case AllModes.NONE_IS_ALL:
      newValues = [];
      break;
    default:
      return;
  }
  onChange(newValues);
};
var isAllSelected = (allMode, selected, available) => {
  var empty = isEmpty(selected);
  var allSelected = isEqual(available.map(each => each.value), selected);
  switch (allMode) {
    case AllModes.NONE_IS_ALL:
      return empty;
    case AllModes.ALL_IS_ALL:
      return empty || allSelected;
    default:
      return allSelected;
  }
};
var doCheckboxChange = (value, checked, selected, onChange) => {
  var selectedItems = selected.filter(each => each !== value);
  if (checked) {
    selectedItems.push(value);
  }
  onChange(selectedItems);
};
var getAllValue = all => all === 'none' ? [] : [{
  value: ALL,
  label: all === AllModes.TOGGLE ? 'All / None' : 'All'
}];
export var BaseAllhomesCheckboxList = _ref => {
  var className = _ref.className,
    _ref$available = _ref.available,
    available = _ref$available === void 0 ? [] : _ref$available,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? [] : _ref$selected,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange,
    _ref$all = _ref.all,
    all = _ref$all === void 0 ? AllModes.NONE : _ref$all,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {} : _ref$media,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment;
  var allSelected = isAllSelected(all, selected, available);
  var items = getAllValue(all);
  var checkboxes = [...items, ...available].map(_ref2 => {
    var value = _ref2.value,
      label = _ref2.label,
      isNew = _ref2.isNew;
    return ___EmotionJSX("li", {
      css: styles.item({
        alignment
      }),
      key: value
    }, ___EmotionJSX(Checkbox, _extends({
      name: value,
      id: value,
      value: value,
      onChange: _ref3 => {
        var target = _ref3.target;
        return value === ALL ? doCheckboxHandleAll(all, selected, available, _onChange) : doCheckboxChange(target.value, target.checked, all === AllModes.ALL_IS_ALL && allSelected ? [] : selected, _onChange);
      },
      labelContent: label,
      checked: value === ALL ? allSelected : selected.includes(value) && (all !== AllModes.ALL_IS_ALL || !allSelected),
      size: media.desktop ? 'default' : 'large'
    }, alignment === 'right' ? {
      appearance: 'full-width-label-left'
    } : {})), isNew && ___EmotionJSX("span", {
      css: styles.newItem({
        alignment,
        desktop: media === null || media === void 0 ? void 0 : media.desktop
      })
    }, "New"));
  });
  return ___EmotionJSX("div", null, ___EmotionJSX("ul", {
    className: className,
    css: styles.list
  }, checkboxes));
};
export var AllhomesCheckboxList = withMedia(BaseAllhomesCheckboxList);